import { defaultContentElement } from "../models/defaultElements";
import { securityHelper } from "../../helpers/securityHelper";
import { elementConstants } from "../../constants/cms/form/element/element.constants";
import { sourceTypes } from "../../constants/cms/sourceType";
import { deepClone } from "../../helpers/objectHelper";

export const contentHelper = {
    create
};

function getNewId(elements) {
    const contents =
        elements.filter(el => el.type === elementConstants.CONTENT)
        ;

    if (!contents.length > 0) {
        return 0;
    }

    return contents.length * -1;
}

function create(
    source,
    sourceType,
    selectedEl,
    destination
) {
    let eventId = null;
    let langCode = null;
    let elements = null;
    let currentPage = null;
    let formId = null;
    let pageId = null;
    let templateId = null;

    if (sourceType === sourceTypes.FORM) {
        elements = source.formElements;
        currentPage = source.currentPage
        eventId = source.eventId;
        langCode = source.languageCode;
        formId = source.formId;
    }
    if (sourceType === sourceTypes.PAGE) {
        elements = source.pageElements
        currentPage = source.currentPage
        eventId = source.eventId
        langCode = source.languageCode;
        pageId = source.pageId;
    }
    if (sourceType === sourceTypes.TEMPLATE) {
        elements = source;
        eventId = source.eventId;
        langCode = source.languageCode
        currentPage = 1
    }
    let newEl = deepClone(defaultContentElement);
    newEl.sortOrder = destination.index;
    newEl.formId = formId;
    newEl.eventId = eventId;
    newEl.parentId = null;
    newEl.pageId = pageId;
    newEl.id = getNewId(elements);
    newEl.languageCode = langCode;
    newEl.contentId = securityHelper.createGuid();
    newEl.page = currentPage;
    newEl.props = {
        ...defaultContentElement.props,
        type: selectedEl.type
    };
    newEl.data = selectedEl.settings;
    return newEl;
}
